import React, { Component } from 'react';
import { Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CARD_PADDING = 22;
const CARD_STYLE = { cursor: 'pointer', height: '150px' };

class SVGColCard extends Component {
  cardComponent = React.createRef();

  state = {
    height: 0,
    width: 0
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () =>
    this.setState({
      height: this.cardComponent.current.offsetHeight,
      width: this.cardComponent.current.offsetWidth
    });

  onMouseEnter = event => {
    const { name, onGraphHover } = this.props;
    onGraphHover(name);
    event.currentTarget.classList.add('bg-primary');
  };

  onMouseLeave = event => {
    const { onGraphHover } = this.props;
    onGraphHover('');
    event.currentTarget.classList.remove('bg-primary');
  };

  render() {
    const { children, title, onClick } = this.props;
    const { width, height } = this.state;
    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        width: width - CARD_PADDING * 2,
        height: height - CARD_PADDING * 2,
        isCard: true
      })
    );

    return (
      <Col xs={4} className="px-1">
        <Card
          title={title}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          style={CARD_STYLE}
          ref={this.cardComponent}
          onClick={onClick}
        >
          <Card.Body>{childrenWithProps}</Card.Body>
        </Card>
      </Col>
    );
  }
}
SVGColCard.propTypes = {
  children: PropTypes.node.isRequired,
  onGraphHover: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default SVGColCard;
